import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";


// Reducers
import auth from "./auth";
import education from "./education";
import interactiveEducation from "./interactiveEducation";
import style from "./style";

// Persist configs
const persistConfig = {
    key: "root",
    storage,
    whitelist: ["auth"]
};

const rootReducer = combineReducers({ auth, education, interactiveEducation, style });

export default persistReducer(persistConfig, rootReducer);
